import {
  GET_PROBLEMS,
  PROBLEM_ERROR,
  GET_PROBLEM,
  CLEAR_PROBLEM,
} from "../actions/types";

const initialState = {
  problems: [],
  problem: null,
  error: {},
  loading: true,
};

export default function (state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case GET_PROBLEMS:
      return {
        ...state,
        problems: payload,
        loading: false,
      };
    case GET_PROBLEM:
      return {
        ...state,
        problem: payload,
        loading: false,
      };
    case PROBLEM_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case CLEAR_PROBLEM:
      return {
        ...state,
        problem: null,
        loading: false,
      };
    default:
      return state;
  }
}
